import { render, staticRenderFns } from "./enderecos.vue?vue&type=template&id=1aa585ea&scoped=true&"
import script from "./enderecos.vue?vue&type=script&lang=js&"
export * from "./enderecos.vue?vue&type=script&lang=js&"
import style0 from "./enderecos.vue?vue&type=style&index=0&id=1aa585ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa585ea",
  null
  
)

export default component.exports